export const ASSETS_APP_KEY = 'ASSETS';
export const TENANTLESS_ORG_ID = 'tenantless';

// ARIA tabs id prefixes for the App Switcher for Units rail (tabs) and content column (tabpanel).
export const SWITCHER_TAB_BUTTON_PREFIX = 'switcher-tab';
export const SWITCHER_TAB_PANEL_PREFIX = 'switcher-tabpanel';

// App Switcher for Units resizable rail consts. Widths are unitless pixel
// numbers so the resize state machine can do arithmetic on them; consumers
// append `px` when applying to the DOM.
export const ORG_UNIT_RAIL_COLLAPSED_WIDTH = 72;
export const ORG_UNIT_RAIL_DEFAULT_WIDTH = 268;
export const ORG_UNIT_RAIL_MAX_WIDTH = 400;
// Below this drag width the rail snaps closed to the collapsed width.
export const ORG_UNIT_RAIL_MIN_EXPAND_WIDTH = 136;
// Fixed width of the panel's right-hand content column (the app list).
export const ORG_UNIT_CONTENT_WIDTH = 336;
// Delay before the resize handle's tooltip appears, in ms.
export const ORG_UNIT_RESIZE_TOOLTIP_DELAY_MS = 1000;

// Pointer travel (px) before a press counts as a drag rather than a click. Guards
// the click-to-toggle affordance against hand jitter.
export const ORG_UNIT_RAIL_DRAG_THRESHOLD_PX = 3;

// localStorage key persisting the user's chosen rail width. Reuses the key from
// the removed org-selector resize implementation so no new key needs allowlisting.
export const ORG_UNIT_RAIL_WIDTH_LS_KEY = 'AS_ORG_SELECTOR_WIDTH';

// Because the storage key is shared with the removed org-selector, a bare number
// could have been written by that feature rather than by this rail, and any small
// value clamps up to the collapsed width — pinning the rail closed on open. Only
// values this rail wrote carry the prefix; everything else is treated as "no
// preference" and replaced the next time the user resizes.
const RAIL_WIDTH_VALUE_PREFIX = 'railWidth:';

export const serialisePersistedRailWidth = (width: number): string =>
	`${RAIL_WIDTH_VALUE_PREFIX}${width}`;

// Interprets a stored rail width, clamped into the [collapsed, max] range and
// falling back to the default when nothing is stored or the value is invalid.
// Callers should prefer `readRailWidth`, which layers this over the width
// committed during the current page load.
export const getPersistedRailWidth = (widthFromStorage: string | null): number => {
	if (!widthFromStorage?.startsWith(RAIL_WIDTH_VALUE_PREFIX)) {
		return ORG_UNIT_RAIL_DEFAULT_WIDTH;
	}

	const parsed = parseInt(widthFromStorage.slice(RAIL_WIDTH_VALUE_PREFIX.length), 10);
	return Number.isFinite(parsed)
		? Math.min(Math.max(parsed, ORG_UNIT_RAIL_COLLAPSED_WIDTH), ORG_UNIT_RAIL_MAX_WIDTH)
		: ORG_UNIT_RAIL_DEFAULT_WIDTH;
};
